module.exports = __webpack_public_path__ + "img/bb_g3_antenna-04.990746ff.svg";